<script>
  export let data;
</script>

<div class="p-4 mx-auto">
  <div class="space-y-3 max-w-2xl mx-auto">
    <!-- UDI Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center"></div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Product Name</div>
        <div class="text-sm font-semibold text-gray-900">{data.name}</div>
        <div class="text-xs text-gray-600 mt-1 mb-0">Product Version</div>
        <div class="text-sm font-semibold text-gray-900">{data.version}</div>
      </div>
    </div>

    <!-- Medical Device Symbol -->
    {#if data.medicalDevice}
    <div class="flex items-center gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/MD.svg" alt="Medical Device" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-sm font-semibold text-gray-900">{data.medicalDevice}</div>
      </div>
    </div>
    {/if}

    <!-- UDI Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/UDI.svg" alt="UDI" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Device Identifier</div>
        <div class="text-sm font-semibold text-gray-900">{data.serialNumber}</div>
        <div class="text-xs text-gray-600 mt-1 mb-0">Production Identifier</div>
        <div class="text-sm font-semibold text-gray-900">{data.productionId}</div>
      </div>
    </div>
    
    <!-- Release Date (no symbol) -->
    {#if data.releaseDate}
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <!-- No symbol for release date -->
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Release Date</div>
        <div class="text-sm font-semibold text-gray-900">{data.releaseDate}</div>
      </div>
    </div>
    {/if}
    
    <!-- REF Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/REF.svg" alt="REF" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Reference Number</div>
        <div class="text-sm font-semibold text-gray-900">{data.refNumber}</div>
      </div>
    </div>
    
    <!-- Consult Instructions Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/Info.svg" alt="Consult Instructions" class="w-8 h-8" />
      </div>
      <div class="flex-1 space-y-2">
        {#if data.instructionsUrl}
        <div>
          <div class="text-xs text-gray-600 mb-0">Instructions for Use - Cloud</div>
          <a href={data.instructionsUrl} target="_blank" rel="noopener noreferrer" class="text-sm font-semibold text-gray-900 hover:underline break-all">{data.instructionsUrl}</a>
        </div>
        {/if}
        {#if data.instructionsUrlIos}
        <div>
          <div class="text-xs text-gray-600 mb-0">Instructions for Use - iOS</div>
          <a href={data.instructionsUrlIos} target="_blank" rel="noopener noreferrer" class="text-sm font-semibold text-gray-900 hover:underline break-all">{data.instructionsUrlIos}</a>
        </div>
        {/if}
        {#if data.instructionsUrlAndroid}
        <div>
          <div class="text-xs text-gray-600 mb-0">Instructions for Use - Android</div>
          <a href={data.instructionsUrlAndroid} target="_blank" rel="noopener noreferrer" class="text-sm font-semibold text-gray-900 hover:underline break-all">{data.instructionsUrlAndroid}</a>
        </div>
        {/if}
        {#if data.phoneCompatibilityUrl}
        <div>
          <div class="text-xs text-gray-600 mb-0">Phone Compatibility List</div>
          <a href={data.phoneCompatibilityUrl} target="_blank" rel="noopener noreferrer" class="text-sm font-semibold text-gray-900 hover:underline break-all">{data.phoneCompatibilityUrl}</a>
        </div>
        {/if}
      </div>
    </div>
    
    <!-- Manufacturer Symbol (Solid factory building) -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/Factory-Filled.svg" alt="Manufacturer" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Manufacturer</div>
        <div class="text-sm font-semibold text-gray-900">{data.manufacturer.name}</div>
        <div class="text-sm text-gray-900 mt-0">{data.manufacturer.address1}</div>
        <div class="text-sm text-gray-900 mt-0">{data.manufacturer.address2}</div>
      </div>
    </div>

    <!-- EU Representative Symbol -->
    {#if data.euRepresentative && data.euRepresentative.name}
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/EU-REP.svg" alt="EU Representative" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">EU Representative</div>
        <div class="text-sm font-semibold text-gray-900">{data.euRepresentative.name}</div>
        <div class="text-sm text-gray-900 mt-0">{data.euRepresentative.address1}</div>
        <div class="text-sm text-gray-900 mt-0">{data.euRepresentative.address2}</div>
      </div>
    </div>
    {/if}

    <!-- Customer Service -->
    {#if data.customerServiceUrl}
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Customer Service</div>
        <div class="text-sm font-semibold text-gray-900">{data.customerServiceUrl}</div>
      </div>
    </div>
    {/if}
  </div>
</div>

